import React from 'react';

const JobDescriptionForm = ({ jobDescriptionData, errors, isProcessing, onInputChange }) => {
    return (
        <div className="mb-8">
            {/* Job Description Header */}
            <div className="mb-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    Paste Your Job Description
                </h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                    Paste the complete job description below. Our AI will automatically extract the job title, 
                    required skills, experience level, and other criteria from your job posting.
                </p>
            </div>

            {/* Job Description Textarea */}
            <div className="mb-6">
                <textarea
                    placeholder="Paste your complete job description here..."
                    value={jobDescriptionData.jobDescription}
                    onChange={(e) => onInputChange('jobDescription', e.target.value)}
                    className={`w-full max-w-4xl mx-auto p-6 border-2 rounded-xl text-base outline-none transition-all min-h-[300px] resize-y font-mono ${
                        errors.jobDescription 
                            ? 'border-red-300 focus:border-red-400 bg-red-50' 
                            : 'border-gray-200 focus:border-gray-400 bg-white'
                    }`}
                    disabled={isProcessing}
                />
                
                {/* Character Count */}
                <div className="flex justify-between items-center mt-2 max-w-4xl mx-auto text-sm text-gray-500">
                    <div>
                        {errors.jobDescription && (
                            <span className="text-red-600 font-medium">
                                ⚠️ {errors.jobDescription}
                            </span>
                        )}
                    </div>
                    <div className="flex items-center gap-2">
                        <span>{jobDescriptionData.jobDescription.length} characters</span>
                        {jobDescriptionData.jobDescription.length >= 50 && (
                            <span className="text-green-600">✓</span>
                        )}
                    </div>
                </div>
            </div>

            {/* NEW: Exclusion Criteria */}
            <div className="mb-6 max-w-4xl mx-auto">
                <input
                    type="text"
                    placeholder="Exclusion Keywords (Optional - comma separated: O9 Solutions, Oracle EBS...)"
                    value={jobDescriptionData.exclusionCriteria || ''}
                    onChange={(e) => onInputChange('exclusionCriteria', e.target.value)}
                    className={`w-full p-4 border-2 rounded-xl text-lg outline-none transition-all ${
                        errors.exclusionCriteria 
                            ? 'border-red-300 focus:border-red-500' 
                            : 'border-gray-200 focus:border-gray-400'
                    }`}
                    disabled={isProcessing}
                />
                <div className="flex justify-between items-center mt-2">
                    {jobDescriptionData.exclusionCriteria && jobDescriptionData.exclusionCriteria.length > 0 && (
                        <div className="text-sm text-orange-600 font-medium">
                            {jobDescriptionData.exclusionCriteria.split(',').length} exclusion(s)
                        </div>
                    )}
                </div>
                {errors.exclusionCriteria && (
                    <div className="text-red-500 text-sm mt-1 text-left">
                        {errors.exclusionCriteria}
                    </div>
                )}
            </div>

            {/* Preview Area (if job description is long enough) */}
            {jobDescriptionData.jobDescription.length > 100 && (
                <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-4 max-w-3xl mx-auto">
                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                        👁️ Preview
                    </h4>
                    <div className="text-sm text-gray-600 leading-relaxed max-h-32 overflow-y-auto">
                        {jobDescriptionData.jobDescription.substring(0, 300)}
                        {jobDescriptionData.jobDescription.length > 300 && '...'}
                    </div>
                    <div className="mt-2 text-xs text-gray-500 flex justify-between items-center">
                        <span>Ready for AI analysis • {Math.ceil(jobDescriptionData.jobDescription.length / 4)} estimated tokens</span>
                        {jobDescriptionData.exclusionCriteria && (
                            <span className="text-orange-600">
                                + {jobDescriptionData.exclusionCriteria.split(',').length} exclusion criteria
                            </span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default JobDescriptionForm;